export enum CourseReferenceType {
    Course,
    LearningPath,
    Group
}